import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-data-management',
	templateUrl: './dashboard.component.html',
	standalone: false,
})
export class DataManagementDashboardComponent {
	constructor(private router: Router) {}

	goToImpersonate() {
		void this.router.navigate([
			'/app/f5596e17-338b-4898-8a71-a05b04adf13b/impersonate',
		]);
	}
}
